/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Select, MenuItem, SelectChangeEvent, Button } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import React, { Dispatch, SetStateAction, useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";
import { Offers } from "../../types/General";
import moment from "moment";

type props = {
  rows: Offers[];
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  loading: boolean;
  count: number;
  handlePageChange: (event: any, newPage: number) => void;
  handleStatusUpdate: (status: number) => void;

  setRejectionRsn: Dispatch<SetStateAction<string>>;
  rejectionRsn: string;
  setCommission: Dispatch<SetStateAction<string>>;
  commission: string;
  setSelectedId: Dispatch<SetStateAction<string>>;

  setOpen1: Dispatch<SetStateAction<boolean>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  open1: boolean;
  setSelectedPrice: Dispatch<SetStateAction<string>>;
  selectedPrice: string;
  setDocOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedQuatation: Dispatch<SetStateAction<string>>;
  selectedQuatation: string;

  setPdfFile: Dispatch<SetStateAction<string>>;
  pdfFile: string;
};

const OffersPendingList = ({
  count,
  loading,
  page,
  rows,
  setPage,
  handlePageChange,
  handleStatusUpdate,
  commission,
  rejectionRsn,
  setCommission,
  setRejectionRsn,
  setSelectedId,
  open,
  open1,
  setOpen,
  setOpen1,
  setSelectedPrice,
  selectedPrice,
  setDocOpen,
  setSelectedQuatation,
  selectedQuatation,
  pdfFile,
  setPdfFile,
}: props) => {
  const navigate = useNavigate();

  const [selectField1, setSelectField1] = React.useState("default");

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "maintenance",
      headerName: "Maintenance Team Detail",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>{row?.user?.fullName || "-"}</b>{" "}
              <span>{row?.user?.email || "-"}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "offered",
      headerName: "Quoted Price",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <p className="c_primary">
            <strong>AED {row?.price || "0"}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "time",
      headerName: "Est. Timeline",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return <p className="c_primary">{row?.time || "0"} hours</p>;
      },
    },
    {
      minWidth: 150,
      field: "date",
      headerName: "Offer Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_primary">
            <strong>{moment(row?.createdAt).format("DD MMM YYYY")}</strong>
          </p>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "document",
      headerName: "Quotation",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() => {
              if (row?.quoatation) {
                window.open(row.quoatation, "_blank");
              }
            }}
          >
            View
          </Button>
        );
      },
    },

    {
      minWidth: 180,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Select fullWidth value={selectField1} onChange={handleChange1}>
            <MenuItem disabled value="default">
              Select Status
            </MenuItem>
            <MenuItem
              value={10}
              onClick={() => {
                setSelectedId(row?._id);
                setSelectedPrice(String(row?.price) || "0");
                setOpen(true);
              }}
            >
              Accept
            </MenuItem>
            <MenuItem
              value={10}
              onClick={() => {
                setSelectedId(row?._id);
                setOpen1(true);
              }}
            >
              Reject
            </MenuItem>
          </Select>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </div>

      <CommissionOfferModal
        open={open}
        onClose={handleStatusUpdate}
        setOpen={setOpen}
        setCommission={setCommission}
        setPdfFile={setPdfFile}
        pdfFile={pdfFile}
        commission={commission}
        selectedPrice={selectedPrice}
      />
      <RejectReasonModal
        open={open1}
        onClose={handleStatusUpdate}
        setOpen={setOpen1}
        setRejectionRsn={setRejectionRsn}
        rejectionRsn={rejectionRsn}
      />
    </>
  );
};

export default OffersPendingList;
